const positions = new Map<string, number>();

export function mainScrollKey(pathname: string, search = ''): string {
  return `${pathname}${search || ''}`;
}

export function canHoldScroll(
  el: { scrollHeight: number; clientHeight: number } | null | undefined,
  top: number,
): boolean {
  if (!el || !(top > 0)) return true;
  return el.scrollHeight - el.clientHeight >= top - 1;
}

export function saveMainScroll(
  key: string,
  top: number,
  el?: { scrollHeight: number; clientHeight: number } | null,
): void {
  if (!key) return;
  const n = Number(top);
  const next = Number.isFinite(n) && n > 0 ? n : 0;
  const prev = positions.get(key);
  if (prev != null && prev > next && el && !canHoldScroll(el, prev)) return;
  positions.set(key, next);
}

export function readMainScroll(key: string): number | undefined {
  return positions.get(key);
}

export function restoreMainScroll(
  el: { scrollTop: number; scrollHeight?: number; clientHeight?: number } | null | undefined,
  key: string,
): boolean {
  if (!el) return false;
  const saved = positions.get(key);
  if (saved == null) return false;
  const max =
    typeof el.scrollHeight === 'number' && typeof el.clientHeight === 'number'
      ? Math.max(0, el.scrollHeight - el.clientHeight)
      : saved;
  el.scrollTop = Math.min(saved, max);
  if (typeof window !== 'undefined' && saved > 0 && typeof window.scrollTo === 'function') {
    try {
      window.scrollTo(0, saved);
    } catch {
    }
  }
  return true;
}

export function isMainScrollRestored(
  el: { scrollTop: number; scrollHeight: number; clientHeight: number } | null | undefined,
  key: string,
): boolean {
  const saved = positions.get(key);
  if (saved == null || saved === 0) return true;
  if (!el) return false;
  return canHoldScroll(el, saved) || el.scrollTop >= saved - 1;
}

export function snapshotMainScroll(pathname: string, search = ''): void {
  if (typeof document === 'undefined') return;
  const main = document.getElementById('app-main-scroll');
  const mainTop = main?.scrollTop ?? 0;
  const winTop = window.scrollY || document.documentElement.scrollTop || 0;
  saveMainScroll(mainScrollKey(pathname, search), Math.max(mainTop, winTop), main);
}

export function resetMainScrollPositions(): void {
  positions.clear();
}
